import { Box } from '@hopskipdrive/react-components';
import { colorPalette } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const StyledBox = styled(Box)`
  color: ${colorPalette.neutral50};
`;
